import { render, staticRenderFns } from "./ButtonModel.vue?vue&type=template&id=46656928&scoped=true"
import script from "./ButtonModel.vue?vue&type=script&lang=js"
export * from "./ButtonModel.vue?vue&type=script&lang=js"
import style0 from "./ButtonModel.vue?vue&type=style&index=0&id=46656928&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46656928",
  null
  
)

export default component.exports